<template>
    <div class="configurator-page-filters">
       <h2>{{pointStore.filter.filterHeading}}</h2>
       <p>{{pointStore.filter.filterText}}</p>
      
       <div class="configurator-page-filters__container">
            <categoryfilter
                :categories="categories"
                @clicked="toggleSelected" 
                @toggleCategory="toggleCategory">
            </categoryfilter>
            <depthfilter 
                :depths="depths" 
                @clicked="toggleSelected" 
                @toggleDepth="toggleDepth">
            </depthfilter>
            <productfilter 
                :products="products"
                @clicked="toggleSelected" 
                @toggleProduct="toggleProduct">
            </productfilter>
        </div>
    </div>
</template>

<script setup>
    import categoryfilter from './category-filter.vue';
    import depthfilter from './depth-filter.vue';
    import productfilter from './product-filter.vue';
    import { usePointStore } from '../store/store';

    const pointStore = usePointStore();
    
    const props = defineProps({
        products: Object,
        categories: Object,
        depths: Object,
        filter: Object
    });
    
    const emit = defineEmits([
        'toggleSelected', 
        'toggleCategory',
        'toggleProduct',
        'toggleDepth'
    ]);
    
    function toggleSelected(object) {
        emit('toggleSelected', object);
    }
    function toggleCategory(category){
        emit('toggleCategory', category);
    }
    function toggleProduct(product){
        emit('toggleProduct', product);
    }
    function toggleDepth(depth){
        emit('toggleDepth', depth);
    }
    
  
</script>